<div class="activity-layout">
  <!-- Sidebar with Type filtering -->
  <div class="activity-sidebar" [class.collapsed]="isLeftSidebarCollapsed || filterMode === 'datasource'">
    <div 
      class="sidebar-toggle-btn" 
      (click)="toggleLeftSidebar()"
      [matTooltip]="isLeftSidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'"
      matTooltipPosition="right"
      *ngIf="filterMode !== 'datasource'">
      <mat-icon>{{ isLeftSidebarCollapsed ? 'chevron_right' : 'chevron_left' }}</mat-icon>
    </div>
    <div class="sidebar-header-background">
      <h2>Activity</h2>
    </div>
    
    <!-- Type Filter Cards -->
    <div class="filter-list">
      <div *ngFor="let typeCard of typeCards" 
           class="card-selectable filter-item"
           [class.selected]="selectedType === typeCard.id"
           (click)="onTypeSelect(typeCard.id)">
        <div class="filter-info">
          <mat-icon [svgIcon]="selectedType === typeCard.id ? typeCard.iconActive : typeCard.icon" class="filter-icon"></mat-icon>
          <div class="filter-name">{{ typeCard.label }}</div>
        </div>
        <div class="filter-actions">
          <div class="filter-count">{{ typeCard.count }}</div>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Main Content Area in Off-White Layer -->
  <div class="content-wrapper-parent">
    <div class="content-wrapper">
      <div class="activity-content">
        <!-- Datasource Filter Banner -->
        <div *ngIf="filterMode === 'datasource'" class="datasource-filter-banner">
          <button mat-icon-button (click)="navigateToDataSources()" matTooltip="Back to Data Sources" class="back-button">
            <mat-icon>arrow_back</mat-icon>
          </button>
          <div class="banner-content">
            <mat-icon svgIcon="filter"></mat-icon>
            <span>Showing cleaning workflows using: <strong>{{ selectedDatasourceName }}</strong></span>
          </div>
          <button mat-icon-button (click)="clearDatasourceFilter()" matTooltip="Clear filter">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        
        <div class="page-header">
          <h1>{{ getPageTitle() }}</h1>
          <div class="header-actions-right">
            <mat-form-field class="search-box" appearance="outline">
              <mat-icon matPrefix svgIcon="search"></mat-icon>
              <input matInput placeholder="Search activity..." [(ngModel)]="searchQuery" (ngModelChange)="applyTableFilter($event)">
              <button *ngIf="searchQuery" matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>

            <button mat-icon-button
              *ngIf="filterMode !== 'datasource'"
              [matMenuTriggerFor]="filterMenu"
              [disabled]="selectedType === 'dataprofile' || selectedType === 'anomalydetection'"
              class="filter-button"
              aria-label="Filter"
              [matTooltip]="getFilterButtonTooltip()">
              <mat-icon svgIcon="filter-white"></mat-icon>
            </button>

            <mat-menu #filterMenu="matMenu">
              <!-- All Activity: filter by item type -->
              <ng-container *ngIf="selectedType === 'all'">
                <button mat-menu-item (click)="setSubFilter('all')">
                  <mat-icon *ngIf="subFilter === 'all'" svgIcon="check_circle_black"></mat-icon>
                  <span [class.font-semibold]="subFilter === 'all'">All Types</span>
                </button>
                <button mat-menu-item (click)="setSubFilter('project')">
                  <mat-icon *ngIf="subFilter === 'project'" svgIcon="check_circle_black"></mat-icon>
                  <span [class.font-semibold]="subFilter === 'project'">Cleaning Workflows</span>
                </button>
                <button mat-menu-item (click)="setSubFilter('dataprofile')">
                  <mat-icon *ngIf="subFilter === 'dataprofile'" svgIcon="check_circle_black"></mat-icon>
                  <span [class.font-semibold]="subFilter === 'dataprofile'">Data Assessments</span>
                </button>
                <button mat-menu-item (click)="setSubFilter('anomalydetection')">
                  <mat-icon *ngIf="subFilter === 'anomalydetection'" svgIcon="check_circle_black"></mat-icon>
                  <span [class.font-semibold]="subFilter === 'anomalydetection'">Anomaly Detection</span>
                </button>
              </ng-container>

              <!-- Projects: filter by clean status -->
              <ng-container *ngIf="selectedType === 'project'">
                <button mat-menu-item (click)="setSubFilter('all')">
                  <mat-icon *ngIf="subFilter === 'all'" svgIcon="check_circle_black"></mat-icon>
                  <span [class.font-semibold]="subFilter === 'all'">All Statuses</span>
                </button>
                <button mat-menu-item (click)="setSubFilter('99')">
                  <mat-icon [svgIcon]="getFilterStatusIcon('99')" [class]="getFilterStatusClass('99')" class="status-icon"></mat-icon>
                  <span [class.font-semibold]="subFilter === '99'">Incomplete Setup</span>
                  <mat-icon *ngIf="subFilter === '99'" svgIcon="check_circle_black" class="selected-check"></mat-icon>
                </button>
                <button mat-menu-item (click)="setSubFilter('1')">
                  <mat-icon [svgIcon]="getFilterStatusIcon('1')" [class]="getFilterStatusClass('1')" class="status-icon"></mat-icon>
                  <span [class.font-semibold]="subFilter === '1'">Not Started</span>
                  <mat-icon *ngIf="subFilter === '1'" svgIcon="check_circle_black" class="selected-check"></mat-icon>
                </button>
                <button mat-menu-item (click)="setSubFilter('2')">
                  <mat-icon [svgIcon]="getFilterStatusIcon('2')" [class]="getFilterStatusClass('2')" class="status-icon"></mat-icon>
                  <span [class.font-semibold]="subFilter === '2'">In Progress</span>
                  <mat-icon *ngIf="subFilter === '2'" svgIcon="check_circle_black" class="selected-check"></mat-icon>
                </button>
                <button mat-menu-item (click)="setSubFilter('3')">
                  <mat-icon [svgIcon]="getFilterStatusIcon('3')" [class]="getFilterStatusClass('3')" class="status-icon"></mat-icon>
                  <span [class.font-semibold]="subFilter === '3'">Successful</span>
                  <mat-icon *ngIf="subFilter === '3'" svgIcon="check_circle_black" class="selected-check"></mat-icon>
                </button>
                <button mat-menu-item (click)="setSubFilter('4')">
                  <mat-icon [svgIcon]="getFilterStatusIcon('4')" [class]="getFilterStatusClass('4')" class="status-icon"></mat-icon>
                  <span [class.font-semibold]="subFilter === '4'">Failed</span>
                  <mat-icon *ngIf="subFilter === '4'" svgIcon="check_circle_black" class="selected-check"></mat-icon>
                </button>
              </ng-container>
            </mat-menu>
          </div>
        </div>
        
        <!-- Activity Table -->
        <div *ngIf="!loading" class="table-wrapper">
          <!-- Empty state when error occurred -->
          <div *ngIf="error" class="error-container">
            <mat-icon color="warn">error</mat-icon>
            <p>Unable to load activity. Please try again.</p>
          </div>
          
          <div *ngIf="!error" class="activity-table-container table-container">
            <table mat-table [dataSource]="dataSource" matSort #sortTable="matSort" class="activity-table">
    
            <!-- Icon Column -->
            <ng-container matColumnDef="icon">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let item" class="icon-cell">
                <mat-icon [svgIcon]="getActivityIcon(item)" class="activity-icon"></mat-icon>
              </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
              <td mat-cell *matCellDef="let item" class="activity-name">{{ item.projectName || item.dataSourceName || item.name }}</td>
            </ng-container>

            <!-- Status Column (Projects only) -->
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
              <td mat-cell *matCellDef="let item" class="status-cell">
                <div class="status-display">
                  <mat-icon [svgIcon]="getStatusIcon(item)" [class]="getStatusClass(item)" [matTooltip]="getCleanStatus(item)"></mat-icon>
                  <!-- <span class="status-text" [class]="getStatusClass(item)">{{ getCleanStatus(item) }}</span> -->
                </div>
              </td>
            </ng-container>

            <!-- Project Data Source Column (Projects only) -->
            <ng-container matColumnDef="projectDataSource">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Data Source</th>
              <td mat-cell *matCellDef="let item">
                <span *ngIf="item.dataSourceName; else noDataSource">{{ item.dataSourceName }}</span>
                <ng-template #noDataSource>
                  <span class="no-datasource-name">No Data Source</span>
                </ng-template>
              </td>
            </ng-container>

            <!-- Goals Column (Projects only) -->
            <ng-container matColumnDef="goals">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Goals</th>
              <td mat-cell *matCellDef="let item">{{ item.goalCount || 0 }}</td>
            </ng-container>

            <!-- Outputs Column (Projects only) -->
            <ng-container matColumnDef="outputs">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Destinations</th>
              <td mat-cell *matCellDef="let item">{{ item.outputCount || 0 }}</td>
            </ng-container>

            <!-- Last Updated Column (Projects only) -->
            <ng-container matColumnDef="updatedAt">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Updated</th>
              <td mat-cell *matCellDef="let item" class="date-cell">{{ formatDate(item.updatedAt) }}</td>
            </ng-container>

            <!-- Created On Column (Data Assessments and Anomaly Detection) -->
            <ng-container matColumnDef="createdOn">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Created On</th>
              <td mat-cell *matCellDef="let item" class="date-cell">{{ formatDate(item.createdAt) }}</td>
            </ng-container>

            <!-- Last Run Column (Projects only) -->
            <ng-container matColumnDef="lastRunAt">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Run</th>
              <td mat-cell *matCellDef="let item" class="date-cell">{{ formatDate(item.lastRunAt) }}</td>
            </ng-container>

            <!-- Source Type Column -->
            <ng-container matColumnDef="sourceType">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
              <td mat-cell *matCellDef="let item">
                {{ getSourceTypeName(item.sourceType) }}
              </td>
            </ng-container>

            <!-- Data Source Name Column -->
            <ng-container matColumnDef="dataSourceName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Data Source Name</th>
              <td mat-cell *matCellDef="let item">
                <span *ngIf="item.dataSourceName; else noDataSource">{{ item.dataSourceName }}</span>
                <ng-template #noDataSource>
                  <span class="no-datasource-name">Opted not to Persist</span>
                </ng-template>
              </td>
            </ng-container>

            <!-- Run Name Column (Anomaly Detection only) -->
            <ng-container matColumnDef="runName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
              <td mat-cell *matCellDef="let item">{{ item.name || '—' }}</td>
            </ng-container>

            <!-- Method Key Column (Anomaly Detection only) -->
            <ng-container matColumnDef="methodKey">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Method</th>
              <td mat-cell *matCellDef="let item">{{ item.methodKey }}</td>
            </ng-container>

            <!-- Last Action Column -->
            <ng-container matColumnDef="lastActionAt">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Action</th>
              <td mat-cell *matCellDef="let item" class="date-cell">{{ formatDate(item.lastActionAt) }}</td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let item" class="actions-cell">

                <!-- Project Actions -->
                <ng-container *ngIf="isProject(item)">
                  <!-- Edit Button - Always visible -->
                  <button mat-icon-button class="action-btn" (click)="onEditProject($event, item)" matTooltip="Edit workflow" aria-label="Edit workflow">
                    <mat-icon svgIcon="pencil-blue"></mat-icon>
                  </button>
                  <!-- Configure Button - Always visible -->
                  <button mat-icon-button class="action-btn" (click)="onOpenCanvas($event, item)" matTooltip="Configure project" aria-label="Configure project">
                    <mat-icon svgIcon="settings-blue"></mat-icon>
                  </button>
                  <!-- Start Pipeline Button -->
                  <button mat-icon-button class="action-btn" 
                          [disabled]="selectedType !== 'all' && !canStartPipeline(item)" 
                          (click)="onStartPipeline($event, item)" 
                          matTooltip="Start workflow"
                          aria-label="Start workflow">
                    <mat-icon svgIcon="play-blue"></mat-icon>
                  </button>
                  <!-- View Outputs Button -->
                  <button mat-icon-button class="action-btn" 
                          [disabled]="selectedType !== 'all' && !canViewOutputs(item)" 
                          (click)="onViewOutputs($event, item)" 
                          matTooltip="View outputs"
                          aria-label="View outputs">
                    <mat-icon svgIcon="visibility-blue"></mat-icon>
                  </button>
                  <!-- Delete Button - Always visible -->
                  <button mat-icon-button class="action-btn delete-btn" (click)="onDeleteProject($event, item)" title="Delete project">
                    <mat-icon svgIcon="delete"></mat-icon>
                  </button>
                </ng-container>

                <!-- Anomaly Detection Actions -->
                <button *ngIf="isAnomalyDetection(item)" mat-icon-button class="action-btn" (click)="onRenameAnomalyDetection($event, item)" matTooltip="Rename run" aria-label="Rename anomaly detection run">
                  <mat-icon svgIcon="pencil-blue"></mat-icon>
                </button>
                <button *ngIf="isAnomalyDetection(item)" mat-icon-button class="action-btn" (click)="onViewAnomalyDetection($event, item)" matTooltip="View results" aria-label="View anomaly detection results">
                  <mat-icon svgIcon="visibility-blue"></mat-icon>
                </button>
                <button *ngIf="isAnomalyDetection(item)" mat-icon-button class="action-btn delete-btn" (click)="onDeleteAnomalyDetection($event, item)" matTooltip="Delete run" title="Delete run">
                  <mat-icon svgIcon="delete"></mat-icon>
                </button>

                <!-- Data Assessment Actions -->
                <button *ngIf="isDataProfile(item)" mat-icon-button class="action-btn" (click)="onRenameDataProfile($event, item)" matTooltip="Rename profile" aria-label="Rename data profile">
                  <mat-icon svgIcon="pencil-blue"></mat-icon>
                </button>
                <button *ngIf="isDataProfile(item)" mat-icon-button class="action-btn" (click)="onViewDataProfile($event, item)" matTooltip="View assessment" aria-label="View data assessment">
                  <mat-icon svgIcon="visibility-blue"></mat-icon>
                </button>
                <button *ngIf="isDataProfile(item)" mat-icon-button class="action-btn delete-btn" (click)="onDeleteDataProfile($event, item)" matTooltip="Delete assessment" title="Delete assessment">
                  <mat-icon svgIcon="delete"></mat-icon>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row 
                *matRowDef="let row; columns: displayedColumns;" 
                class="activity-row"
                  ></tr>
          </table>
          </div>
      </div>
    </div>
  </div>
</div>
